import { gql } from "graphql-request";

export const READ_TENANT_USER_ROLE_ASSIGNMENT_BY_ID = gql`
  query ReadTenantUserRoleAssignmentById($id: ID!) {
    readTenantUserRoleAssignmentById(id: $id) {
      id
      tenantUserId
      tenantRoleId
      isPrimary
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_ROLE_ASSIGNMENTS_BY_TENANT_USER = gql`
  query ReadRoleAssignmentsByTenantUser($tenantUserId: ID!) {
    readRoleAssignmentsByTenantUser(tenantUserId: $tenantUserId) {
      id
      tenantUserId
      tenantRoleId
      isPrimary
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_ASSIGNED_TENANT_ROLES_FOR_TENANT_USER = gql`
  query ReadAssignedTenantRolesForTenantUser($id: ID!) {
    readAssignedTenantRolesForTenantUser(id: $id) {
      id
      name
      description
      mission
    }
  }
`;

export const READ_TENANT_USERS_BY_TENANT = gql`
  query ReadTenantUsersByTenant($tenantId: ID!) {
    readTenantUsersByTenant(tenantId: $tenantId) {
      id
      userId
    }
  }
`;